"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCredits = void 0;
var _1 = require(".");
var Credits = [
    { link: "https://www.flaticon.com/free-icons/bank", text: "Bank icons created by Freepik - Flaticon" },
    { link: "https://www.flaticon.com/free-icons/banker", text: "Banker icons created by Freepik - Flaticon" },
    { link: "https://www.flaticon.com/free-icons/wall", text: "Wall icons created by Freepik - Flaticon" },
    { link: "https://www.flaticon.com/free-icons/money", text: "Money icons created by Dimitry Miroliubov - Flaticon" },
    {
        link: "https://www.flaticon.com/free-icons/construction-and-tools",
        text: "Construction and tools icons created by Marz Gallery - Flaticon",
    },
    {
        link: "https://www.flaticon.com/free-icons/hammer",
        text: "Hammer icons created by Freepik - Flaticon",
    },
    {
        link: "https://www.flaticon.com/free-icons/builder",
        text: "Builder icons created by Freepik - Flaticon",
    },
];
var CreditsNew = [
    "<a href=\"https://www.flaticon.com/free-icons/project\" title=\"project icons\">Project icons created by Smashicons - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/drone\" title=\"drone icons\">Drone icons created by Flat Icons - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/crane\" title=\"crane icons\">Crane icons created by monkik - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/concrete\" title=\"concrete icons\">Concrete icons created by monkik - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/robot\" title=\"robot icons\">Robot icons created by Flat Icons - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/3d-printer\" title=\"3d printer icons\">3d printer icons created by Freepik - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/robot\" title=\"robot icons\">Robot icons created by Freepik - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/medal\" title=\"medal icons\">Medal icons created by Freepik - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/time-is-money\" title=\"time is money icons\">Time is money icons created by Prosymbols - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/question-mark\" title=\"question mark icons\">Question mark icons created by Md Tanvirul Haque - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/ufo\" title=\"ufo icons\">Ufo icons created by Freepik - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/video-player\" title=\"video player icons\">Video player icons created by Freepik - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/energy\" title=\"energy icons\">Energy icons created by Freepik - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/clock\" title=\"clock icons\">Clock icons created by Freepik - Flaticon</a>",
    "<a href=\"https://www.flaticon.com/free-icons/click\" title=\"click icons\">Click icons created by Freepik - Flaticon</a>",
];
var GetCredits = function () {
    var credits = __spreadArray(__spreadArray([], Credits.map(function (a) { return "<a href=\"".concat(a.link, "\" title=\"undefined\">").concat(a.text, "</a>"); }), true), CreditsNew, true).map(function (l) { return l.replace("<a ", "<a target='_blank' "); })
        .join("");
    // yandex doesn't want external links
    if (_1.platform === "yandex") {
        return credits
            .replace(/(<([^>]+)>)/gi, "</br>")
            .split("</br>")
            .filter(function (e) { return !!e; })
            .join("</br>");
    }
    return credits;
};
exports.GetCredits = GetCredits;
